import m, {VnodeDOM} from "mithril";
import $ from "jquery";
import CustomForm from "../../CustomForm";
import Balloon from "./Balloon";
import ICustomFormSettings from "../../ICustomFormSettings";

export default class MinigameBalloon extends CustomForm {
    static readonly GAMEPLAY_TIME_LIMIT = 10;
    static readonly SELECTOR = '.customForm-Minigame-balloon .content';

    private variableName: string|null = null;

    private score = 0;
    private hiscore = 0;
    private balloon: Balloon;
    private explosions: Balloon[] = [];
    private balloons: Balloon[] = [];
    private started: Date|null = null;

    private restTime: number = MinigameBalloon.GAMEPLAY_TIME_LIMIT;
    private ticker: NodeJS.Timeout|null = null;

    private finished: boolean = false;

    private isTouchDevice: boolean|null = null;
    private showIntroHint: boolean = true;

    constructor(settings: ICustomFormSettings) {
        super(settings);
        this.balloon = new Balloon({x: 200, y: 30});
        this.load();
    }

    public rewriteFormControls(): boolean {
        return true;
    }


    //----------//
    // VIEW
    //
    public view() {
        return this.viewLayout([
            this.viewScore(),
            this.viewTimer(),
            this.viewBalloons(),
            this.viewExplosions(),
            this.viewHintKeys(),
            this.viewCutButton(),
            this.viewInflateButton(),
            this.viewStartButton(),
            this.viewGameOver(),
            this.viewFullScreen(),
        ], this.viewControls(this.finished ? 'next' : 'skip'))
    }

    private viewScore() {
        return m('div.score', {}, 'score: '+this.score)
    }

    private viewTimer() {
        if (this.started !== null && this.score) {
            return m('div.timer', {},
                this.restTime.toFixed(0)
            );
        } else {
            return null;
        }
    }

    private viewBalloons() {
        const balloons = [];
        for (let balloon of this.balloons) {
            if (balloon.isOk()) {
                balloons.push( balloon.view() );
            }
        }

        if (!this.explosions.length) {
            balloons.push( this.balloon.view() );
        }

        return m('div.balloons', balloons);
    }

    private viewExplosions() {
        const balloons = [];
        for (let balloon of this.explosions) {
            balloons.push( balloon.view() );
        }

        return m('div.balloons.exploded', balloons);
    }

    private viewCutButton() {
        return m('.cut', {
            onmousedown: (e: MouseEvent) => {e.preventDefault(); this.onCut()},
            ontouchstart: (e: MouseEvent) => {e.preventDefault(); this.onCut()},
            title: this.settings.form.questionary.renderText('cut'),
        }, '')
    }

    private viewStartButton() {
        if (this.started || this.finished) {
            return null;
        } else {
            return m('.start', {
                ontouchstart: (e: TouchEvent) => {
                    this.isTouchDevice = true;
                },
                onclick: (e: MouseEvent) => {
                    this.isTouchDevice = this.isTouchDevice || false;
                    e.preventDefault();
                    this.onStart();
                }
            }, this.settings.form.questionary.renderText('start'))
        }
    }

    private viewFullScreen() {
        if (!document.fullscreenEnabled) {
            return null
        }
        return m(document.fullscreenElement ? '.fullscreen.activated' : '.fullscreen',
            {
                onclick: (e: MouseEvent) => {
                    e.preventDefault();
                    if (document.fullscreenElement) {
                        document.exitFullscreen();
                    } else {
                        $(MinigameBalloon.SELECTOR)[0].requestFullscreen();
                    }
                },
            }, ' ');
    }

    private viewInflateButton() {
        return m('.inflate', {
            onmousedown: (e: MouseEvent) => {e.preventDefault(); this.onInflate()},
            ontouchstart: (e: MouseEvent) => {e.preventDefault(); this.onInflate()},
            title: this.settings.form.questionary.renderText('inflate'),
        }, '')
    }

    private viewHintKeys() {
        let hints = [];
        if (this.settings.form.hint) {
            hints.push(m('div', {}, m.trust(this.settings.form.questionary.renderText(this.settings.form.hint))));
        } else {
            hints = [
                m('div', {}, m.trust(this.settings.form.questionary.renderText('Inflate as many balloons as you can.'))),
                m('div', {}, m.trust(this.settings.form.questionary.renderText('✂️ cut the string&nbsp;&nbsp;&nbsp;gas inflates 🎈'))),
                m('div', {}, m.trust(this.settings.form.questionary.renderText('or use <b>A</b> and <b>L</b> on your keyboard'))),
                m('div', {}, m.trust(this.settings.form.questionary.renderText('You have '+MinigameBalloon.GAMEPLAY_TIME_LIMIT+' secs'))),
                m('div', {}, m.trust(this.settings.form.questionary.renderText('🤞'))),
            ]
        }
        return m('.hints', {}, [
            this.score ? null : m('.message', {}, hints),
            (this.isTouchDevice === null || this.isTouchDevice) ? null : m('.key.cut',{}, 'A'),
            (this.isTouchDevice === null || this.isTouchDevice) ? null : m('.key.inflate',{}, 'L'),
        ])
    }

    private viewGameOver() {
        if (this.finished) {
            let congrats = null;
            if (this.score > 899) {
                congrats = '😍 Grand-ball🎈🎈ni🎈us star 😍';
            } else if (this.score > 699) {
                congrats = ' ⭐ Awesome ⭐'
            } else if (this.score > 499) {
                congrats = "🎈 !!! Yay !!! 🎈"
            } else if (this.score > 399) {
                congrats = "Great 😊👍";
            } else if (this.score > 250) {
                congrats = "Well done 😄";
            }

            return m('.gameOver', {}, [
                m('.thanks', {}, 'Thanks for playing'),
                congrats ? m('.congrats.fade-in-zoom', {}, congrats) : null,

                /*
                // Your
                m('.score', {}, [
                    m('span', 'your score is '),
                    ''+this.score
                ]),
                */

                this.hiscore ? m('.hiscore.fade-in-zoom', {}, m('span', {}, '🏆 '+this.hiscore+' 🏆')) : null,

                /*
                // Next button on gameover screen (due fullscreen)
                m('.next', {
                    onclick: () => this.settings.nextForm()
                    }, this.settings.form.questionary.renderText(this.settings.form.questionary.messages.get('next'))
                ),
                */

                /*
                // RESTART
                m('.restart', {
                    onclick: (e: MouseEvent) => {e.preventDefault(); this.onRestart();},
                }, this.settings.form.questionary.renderText('Restart')),
                */

                /*
                // EXIT
                m('.exit', {
                    onclick: (e: MouseEvent) => {e.preventDefault(); this.settings.nextForm();},
                }, this.settings.form.questionary.renderText('Exit'))
                 */

            ]);
        } else {
            return null;
        }
    }


    //---------------//
    // HANDLERS
    //
    private onCut() {
        if (this.finished || !this.started) {
            return;
        }

        const inflation = this.balloon.getInflation();
        if (inflation > Balloon.MIN_INFLATION) {
            this.score += Math.ceil(inflation*inflation/100)
        }
        this.balloon.cut();
        this.balloon.setPosition(
            this.balloon.willFly() ? this.getBalloonFlyDestination() : this.getBalloonFallDestination()
        );
        this.addNewBalloon();
    }

    private onStart(): void {
        this.started = new Date();
        this.score = 0;
        this.finished = false;
        this.showIntroHint = false;
        this.ticker = setInterval(this.update.bind(this), 50);
        this.balloon.setPosition(this.getBalloonStartPosition());
    }

    private onGameOver(): void {
        if (this.ticker) {
            clearInterval(this.ticker);
        }
        this.hiscore = this.hiscore < this.score ? this.score : this.hiscore;
        this.finished = true;
        this.save();
    }

    private onInflate() {
        if (this.finished || !this.started || this.explosions.length) {
            return;
        }

        if (!this.balloon.inflate()) {
            // balloon exploded
            this.explosions.push(this.balloon);
            setTimeout(()=>{this.explosions.shift()}, 250);
            this.addNewBalloon();
        }
    }

    private onRestart() {
        this.started = new Date();
        this.restTime = MinigameBalloon.GAMEPLAY_TIME_LIMIT;
        this.score = 0;
        this.addNewBalloon();
        this.balloons = [];
        this.finished = false;
        this.onStart();
    }

    private onKeydown(e:KeyboardEvent)
    {
        if (e.key?.toLowerCase() === 'a' ?? e.keyCode === 65) { // Old browsers does not support "key"
            this.onCut();
            m.redraw()
        }
        if (e.key?.toLowerCase() === 'l' ?? e.keyCode === 76) { // Old browsers does not support "key"
            if (this.started) {
                this.onInflate();
            } else {
                this.onStart();
            }
            m.redraw();
        }
    }

    //---------//
    // LOGIC
    //
    private getBalloonStartPosition() {
        const $content = $(MinigameBalloon.SELECTOR);
        return {x: $content.outerWidth()/2, y: 30};
    }

    private getBalloonFlyDestination() {
        const $content = $(MinigameBalloon.SELECTOR);
        return {x: $content.outerWidth()*Math.random(), y: $content.outerHeight()+700};
    }

    private getBalloonFallDestination() {
        const $content = $(MinigameBalloon.SELECTOR);
        return {x: $content.outerWidth()*Math.random(), y: 20 + this.balloons.length/2};
    }

    private addNewBalloon(): void {
        this.balloons.push(this.balloon);
        if (this.balloons.length > 100) {
            this.balloons = [];
        }
        this.balloon = new Balloon(this.getBalloonStartPosition());
    }

    private getGameplayDuration(): number|null {
        if (this.started) {
            // @ts-ignore
            return (new Date() - this.started) / 1000;
        }
        return null;

    }

    private update(): void {
        // start counting time after first balloon successfully released (got some score)
        if (this.started && this.score === 0) {
            this.started = new Date();
        }

        const gameplayDuration = this.getGameplayDuration();
        this.restTime = gameplayDuration === null ?
            MinigameBalloon.GAMEPLAY_TIME_LIMIT :
            MinigameBalloon.GAMEPLAY_TIME_LIMIT - gameplayDuration;
        if (this.restTime < 0) {
            this.restTime = 0;
            this.onGameOver();
        }
        m.redraw();
    }

    private load(): void {
        const variableNames = Object.keys(this.settings.form.variables);
        this.variableName = variableNames.length === 0 ? null : variableNames[0];
        if (this.variableName === null) {
            return;
        }
        const hiscore = this.getVariable(variableNames[0]);
        this.hiscore = Number.isInteger(hiscore) ? Number(this.getVariable(variableNames[0])) : 0;
        if (this.hiscore) {
            this.finished = true;
            this.score = this.hiscore;
        }
        if (!this.finished) {
            this.showIntroHint = false;
        }
    }

    private save(): void {
        if (this.variableName !== null) {
            this.setVariable(this.variableName, this.hiscore);
        }
    }

    //----------------//
    // MITHRIL HOOKS
    //
    public oncreate(vnode: VnodeDOM): void {
        super.oncreate(vnode);
        // @ts-ignore
        $(document).on('keydown', this.onKeydown.bind(this));
    }

    /**
     * clear interval, key mapping, etc.
     */
    public onremove(): void {
        if (this.ticker) {
            clearInterval(this.ticker);
        }
        // @ts-ignore // Consider if is ok to clear all keydown events (attach on document)
        $(document).off('keydown');

        if (document.fullscreenElement) {
            document.exitFullscreen();
        }
    }

}


/* --------------------- :-)

   Joke for better day

 Programming pro tip:
 Code Javascript underwater, so nobody could see you crying.

 ------------------------ */